module.exports = __webpack_public_path__ + "static/img/di@2x.5711048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/di@2x.png
// module id = UTZJ
// module chunks = 2